<app-field
  [focused]="focused"
  [dirty]="!empty"
  [disabled]="disabled"
  [showErrorEnabled]="showErrorEnabled"
>
  <label label *ngIf="!!label">{{ label }}</label>

  <textarea
    field
    #inputEl
    style="resize: {{ resize }}"
    [name]="name ?? ''"
    [placeholder]="placeholder ?? ''"
    [autocomplete]="autocomplete ? 'on' : 'off'"
    [readOnly]="!!readOnly"
    [disabled]="!!disabled"
    [rows]="rows"
    (focus)="onFocusChanged(true)"
    (blur)="onFocusChanged(false)"
    (input)="onInputValue($event)"
    (keydown)="onInputKeydown($event)"
  ></textarea>
</app-field>
